import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NgScrollbarModule } from 'ngx-scrollbar';

const menuList: {
  name: string;
  link: string[] | string;
  type: string;
  exact: boolean;
  icon: string;
  subMenuList?: {
    name: string;
    link: string[] | string;
    type: string;
    exact: boolean;
    icon: string;
  }[];
}[] = [
  {
    name: 'Tickets',
    link: ['/', 'support'],
    type: 'All',
    exact: true,
    icon: 'assets/svgs/menu/dashboard.svg',
  },

  {
    name: 'Log Out',
    link: '/',
    type: 'Danger',
    exact: true,
    icon: 'assets/svgs/menu/log-out.svg',
  },
];

@Component({
  selector: 'app-support-sidemenu',
  standalone: true,
  imports: [
    SvgIconComponent,
    NzToolTipModule,
    RouterModule,
    NgScrollbarModule,
    CommonModule,
    NzMenuModule,
  ],
  templateUrl: './support-sidemenu.component.html',
  styleUrl: './support-sidemenu.component.css',
})
export class SupportSidemenuComponent {
  @Input({ required: true }) isCollapsed = false;

  menuList = signal(menuList);
}
